module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-news-mobile"
  }, [_c('div', {
    staticClass: "fzg-banner"
  }, [_c('fzg-menu'), _vm._v(" "), _c('img', {
    staticClass: "m-banner",
    attrs: {
      "src": require("../../assets/img2/mobile/join/banner.jpg")
    }
  })], 1), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "fzg-value-wrap"
  }, [(false) ? _c('div', {
    staticClass: "value-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/join/title_value.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "value-content"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fzg-join-us-position"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "fzg-join-wrap"
  }, [_c('div', {
    staticClass: "join-group"
  }, [_c('div', {
    staticClass: "group-title"
  }, [_vm._v("社会招聘")]), _vm._v(" "), _c('div', {
    staticClass: "position-list"
  }, _vm._l((_vm.coop_job_list), function(item, index) {
    return (_vm.showAllCoop ? true : index < 9) ? _c('a', {
      staticClass: "position-item",
      attrs: {
        "href": '/join/jd?id=' + item.id,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()
  })), _vm._v(" "), (!_vm.showAllCoop) ? _c('div', {
    staticClass: "more-position",
    on: {
      "click": function($event) {
        _vm.showAllCoop = !_vm.showAllCoop
      }
    }
  }, [_vm._v("更多岗位")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "join-group"
  }, [_c('div', {
    staticClass: "group-title"
  }, [_vm._v("实习生招聘")]), _vm._v(" "), _c('div', {
    staticClass: "position-list"
  }, _vm._l((_vm.intern_job_list), function(item, index) {
    return (_vm.showAllIntern ? true : index < 3) ? _c('a', {
      staticClass: "position-item",
      attrs: {
        "href": '/join/jd?id=' + item.id,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()
  })), _vm._v(" "), (!_vm.showAllIntern) ? _c('div', {
    staticClass: "more-position",
    on: {
      "click": function($event) {
        _vm.showAllIntern = !_vm.showAllIntern
      }
    }
  }, [_vm._v("更多岗位")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "join-mail"
  }, [_vm._v(" 如果您有兴趣应聘，请投递简历到邮箱: hr@xfz.cn ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-point-pc"
  }, [_c('div', {
    staticClass: "value-point"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/mobile/join/intro.jpg"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-join-us-partner"
  }, [_c('div', {
    staticClass: "js-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/join/title_partner.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "join-us-center"
  }, [_c('div', {
    staticClass: "swiper mySwiper swiper-initialized swiper-horizontal swiper-backface-hidden"
  }, [_c('div', {
    staticClass: "swiper-wrapper",
    staticStyle: {
      "transition-duration": "0ms",
      "transform": "translate3d(0px, 0px, 0px)"
    },
    attrs: {
      "aria-live": "polite"
    }
  }, [_c('div', {
    staticClass: "swiper-slide",
    attrs: {
      "aria-label": "1 / 9"
    }
  }, [_c('div', {
    staticClass: "slide-item"
  }, [_vm._v(" 凡卓是个非常温暖、包容的大家庭，小伙伴们都一样年轻，充满热爱与激情。我们服务创业者，因此本身也有创业的心态，平台非常注重每一个人的成长，愿意给大家提供机会，我们始终坚持长期主义，相信专业、真诚与热爱会换来公平的回报，成就客户，同时也成就我们自己的职业生涯 ")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    attrs: {
      "aria-label": "2 / 9"
    }
  }, [_c('div', {
    staticClass: "slide-item"
  }, [_vm._v(" 作为“小饭桌创投”基金团队的成员，我在凡卓集团内感受到了一个创投生态所带来的力量。通过与其他业务团队的紧密协作沟通，我可以更快更全面的获得投资所需的产业认知和市场信息，也可以让我自己的思考和认知得到充分打磨和传播，帮助到更多创业者，产生更大价值。")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    attrs: {
      "aria-label": "3 / 9"
    }
  }, [_c('div', {
    staticClass: "slide-item"
  }, [_vm._v(" 在公司6年半的时间里，公司在不断长大和变强，我也在跟着公司的节奏，不断接受新的挑战与成长。商业环境、战略、业务一直在不断的变化，尤其身处于日新月异的创投圈，但最感动我的是公司和CEO的初心始终未变。我们一直在做帮助创业者从平凡到卓越的服务，无论是早期的创业培训到后来的投融资、基金投资甚至是现在的产业区域落地等。不忘初心，共赴山海，坚持对创业者的热爱，坚持为他们做有价值的事情，利他的同时成就我们自己。")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    attrs: {
      "aria-label": "4 / 9"
    }
  }, [_c('div', {
    staticClass: "slide-item"
  }, [_vm._v(" 这里没有垫底的人，更没有浑水摸鱼的人。同事们都很靠谱，做事认真负责、有原则、有目标、有态度，是非常清楚自己想要什么的一群人。每个人都在尽自己所能做到最好，这种尽自己所能并不是被害怕竞争淘汰的恐惧所驱动的努力，而是由十足的信仰和责任驱动的自然的努力。没有人会push谁，但是大家都足够focus on自己的事情，不会挑别人的刺，不会以“ta是不是偷懒了”为假设前提去看待别人，不会拿同事作为比较。打心底认可公司和自己在做的事，因为非常真诚地欣赏、感激、敬仰彼此而不自觉透露出来的“忠诚”。")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    attrs: {
      "aria-label": "5 / 9"
    }
  }, [_c('div', {
    staticClass: "slide-item"
  }, [_vm._v(" All in 硬科技，All in科技中国。投资者结构发生了巨变——国资崛起，中国的资源配置，越来越多地收拢于国内最大的这个资源体系。在这个背景下，在Long China的前提下，如何应对资金端和资产端两端的巨大变化？如何建立和维护与产业巨头与地方政府的关系？宏观的巨变，是一定会与我们个人的职业发展紧密相连的。在凡卓的日子里，在我们与国内优秀的大型产业方（如欣旺达、保碧等）交流的过程中，在我们与国内前沿的专家（院士与其他清北等校教授）沟通的过程中，在我们和国内强力的投资者/资源统筹者合作中，我有了自己的答案。人的命运，当然要靠自己的奋斗，但更要考虑历史的行程。资本市场发展的方向，是我们早几年就已经看到、近年持续投入、目前布局领先市场的。与最懂行的人同行，不仅仅加速你我短期职场的发展——它更意味着，我们跟外部和内部这群“看得清、拎得清”的人建立了长期的联系，这是长期职业发展所必须的。凡卓集团是国内最早布局硬科技的股权投资服务集团之一，也是最早建立产业和地方政府联系的投资银行之一。我们踏踏实实、坚定前行，方向不同，终点必然不同。有志于躬身入局于中国股权市场大变革的业界精英们，请与我们同行，市场发展，时不我待；加入凡卓，舍我其谁！")])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination swiper-pagination-bullets swiper-pagination-horizontal",
    staticStyle: {
      "bottom": "20px"
    }
  }, [_c('span', {
    staticClass: "swiper-pagination-bullet"
  })]), _vm._v(" "), _c('br'), _c('br')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "join-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/join/title_join.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5689d9f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/join/FzgJoinMobile.vue
// module id = 227
// module chunks = 0